import { render, staticRenderFns } from "./SendSearch.vue?vue&type=template&id=99556542&scoped=true"
import script from "./SendSearch.vue?vue&type=script&lang=js"
export * from "./SendSearch.vue?vue&type=script&lang=js"
import style0 from "./SendSearch.vue?vue&type=style&index=0&id=99556542&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99556542",
  null
  
)

export default component.exports